module.exports = __webpack_public_path__ + "img/seaspotter-background - lowres.e9184833.jpg";